<template>
  <nav class="navbar navbar-expand-lg" role="navigation">
    <div class="container-fluid">

      <router-link class="navbar-brand" to="/welcome">PACMNY</router-link >
      <button v-if="impersonation" class="icon__btn revert" href="#" @click.prevent=revert>Patient Management</button>
      <button v-if="impersonation && !invited" class="icon__btn invite" @click.prevent=invite>Invite</button>
      <button v-if="impersonation && invited" class="icon__btn uninvite" @click.prevent=uninvite>Uninvite</button>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span><font-awesome-icon icon="bars" class="icon"/></span>
      </button>

      <div class="collapse navbar-collapse flex-column" id="navbarSupportedContent">

        <!-- upper nav -->
        <navigation-bar-top></navigation-bar-top>

        <!-- lower nav -->
        <navigation-bar-bottom></navigation-bar-bottom>

      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NavigationBarTop from './NavigationBarTop'
import NavigationBarBottom from './NavigationBarBottom'
import { revertToSelf, invitePatient, uninvitePatient } from '@/api/sessionApi';
import { getImpersonation, getInvited } from "@/data/getters";

export default {
  name: "navigation-bar",
  components: {
    'navigation-bar-top': NavigationBarTop,
    'navigation-bar-bottom': NavigationBarBottom,
  },
  computed: {
    ...mapGetters('login',{
      allData: 'getAllData'
    }),
    impersonation: function() {
      return getImpersonation(this.allData);
    },
    invited: function() {
      return getInvited(this.allData);
    }
  },
  methods: {
    ...mapActions('login',[
      'updateApplicationModel'
    ]),
    revert: function() {
      let loader = this.$loading.show({},{
            after: this.$createElement('div',{},['Reverting back...'])
        });
      revertToSelf()
          .then(()=>setTimeout(()=>{ 
          // this.updateApplicationModel()
          window.location.hash = 'null'
          window.location.reload(); },100
          ))
        // .then(()=>setTimeout(()=>{ 
        //   // this.updateApplicationModel()
        //   window.location.reload(); },3000))
    },
    invite: function() {
      invitePatient()
        .then(()=>setTimeout(()=>{ window.location.reload(); },1000));
    },
    uninvite: function() {
      uninvitePatient()
        .then(()=>setTimeout(()=>{ window.location.reload(); },1000));
    }
  }
}
</script>

<style scoped lang="scss">
  $color-base: #0060ff;
  $color-font: #fff;

  .navbar {
    z-index: -10;
    color: $color-base;
    background: linear-gradient(135deg,rgba(158, 15, 184, 0.70) -10%,rgba(5, 232, 255, 0.8) 180%),
    url('../../../assets/images/nav.jpg');
    background-size: cover;
  }

  .icon__btn {
      // color: white;
      background-color: #b692eb;
      border-radius: 20px;
      border: none;
      /*padding-bottom: 30%;*/
      margin: 10px;
  }

  .navbar-brand {
    color: $color-font;
  }

  .navbar-collapse {
    line-height: 1.0rem;
    padding-top: 0.3rem;
  }

  .navbar-toggler {
    color: #fff;
  }

</style>